import { restoreDocument } from 'api/documents'
import { useConfirm, useAlert } from 'hooks/useDialog'

const useRestore = () => {
  const confirm = useConfirm()
  const alert = useAlert()

  type Prams = {
    objectIDs: string[]
    multi?: boolean
  }
  const restore = async ({ objectIDs, multi }: Prams) => {
    const submit = async () => {
      const { data } = await restoreDocument(objectIDs)
      return data
    }

    const message = `${multi ? '選択したファイル' : 'ファイル'}を復元しますか？`
    const { status, result } = await confirm({
      message,
      onConfirm: submit,
    })

    if (status === 'canceled') {
      return 'canceled'
    }

    if (result?.message !== 'OK') {
      await alert({ message: '復元に失敗しました' })
      return 'ok'
    } else {
      await alert({
        message: '復元しました',
        actionText: !multi ? '戻る' : undefined,
      })
      return 'failed'
    }
  }

  return restore
}

export default useRestore
